<template>
  <div id="company-page" class="min-vh-100 d-flex flex-column">
    <main class="flex-grow-1 bg-light">
      <!-- Hero section -->
      <div class="position-relative overflow-hidden company">
        <img
          src="public/images/pages/company/diesel-engine-workshop.jpg"
          alt="Professional diesel engine components and parts workshop"
          class="w-100 h-100"
          style="object-fit: cover;"
        >
        <div
          class="position-absolute"
          style="top: 0; left: 0; right: 0; bottom: 0; background: linear-gradient(to right, rgba(0,0,0,0.8), rgba(0,0,0,0.6), rgba(0,0,0,0.4));"
        ></div>
        <div class="position-absolute d-flex align-items-center" style="top: 0; left: 0; right: 0; bottom: 0;">
          <div class="container px-4 px-md-5">
            <h1 class="text-white font-weight-bold mb-3 company-title">
              About DEC Industries
            </h1>
            <p class="text-white lead mb-0" style="max-width: 36rem; opacity: 0.9;">
              Your trusted partner for premium diesel engine components across North America
            </p>
          </div>
        </div>
      </div>

      <div class="container oversized-container px-4 py-5 py-md-5" style="max-width: 56rem;">
        <div class="mb-5">
          <h1 class="text-center font-weight-bold mb-4" style="font-size: 2.25rem;">
            About DEC Industries
          </h1>
          <p class="text-center lead text-muted mb-4">
            Your trusted partner for premium diesel engine components across North America
          </p>
          <p class="text-muted mb-4">
            Since our establishment, DEC Industries has been committed to providing the highest quality engine parts
            for heavy-duty applications. We specialize in premium components for leading brands including Cummins,
            CAT, Detroit Diesel, Volvo, and more.
          </p>
          <p class="text-muted mb-0">
            Our extensive inventory and deep industry expertise make us the preferred supplier for fleet operators,
            repair shops, and independent mechanics throughout the United States. We understand the critical nature of
            your operations and ensure every part meets the strictest quality standards.
          </p>
        </div>

        <div class="row mb-5">
          <div class="col-12 col-md-4 mb-4">
            <div class="card border h-100 text-center">
              <div class="card-body p-4">
                <i class="fa-solid fa-users txt-cprimary mb-3 d-block" style="font-size: 3rem;"></i>
                <h3 class="h5 font-weight-bold mb-2">Expert Team</h3>
                <p class="text-muted mb-0">Experienced professionals ready to assist you</p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-4">
            <div class="card border h-100 text-center">
              <div class="card-body p-4">
                <i class="fa-solid fa-award txt-cprimary mb-3 d-block" style="font-size: 3rem;"></i>
                <h3 class="h5 font-weight-bold mb-2">Quality First</h3>
                <p class="text-muted mb-0">Only certified OEM and premium aftermarket parts</p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-4">
            <div class="card border h-100 text-center">
              <div class="card-body p-4">
                <i class="fa-solid fa-location-dot txt-cprimary mb-3 d-block" style="font-size: 3rem;"></i>
                <h3 class="h5 font-weight-bold mb-2">Fast Delivery</h3>
                <p class="text-muted mb-0">Quick shipping nationwide from Los Angeles</p>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white border rounded p-4 p-md-5 mb-5">
          <h2 class="h4 font-weight-bold mb-4">Why Choose DEC Industries?</h2>
          <ul class="list-unstyled text-muted mb-0">
            <li class="d-flex align-items-start mb-3">
              <span class="txt-cprimary mr-2 mt-1">•</span>
              <span>
                <strong>Comprehensive Inventory:</strong> Extensive selection of parts for all major engine brands
              </span>
            </li>
            <li class="d-flex align-items-start mb-3">
              <span class="txt-cprimary mr-2 mt-1">•</span>
              <span>
                <strong>Quality Assurance:</strong> Every part inspected and tested to meet OEM specifications
              </span>
            </li>
            <li class="d-flex align-items-start mb-3">
              <span class="txt-cprimary mr-2 mt-1">•</span>
              <span>
                <strong>Competitive Pricing:</strong> Fair prices without compromising on quality
              </span>
            </li>
            <li class="d-flex align-items-start mb-3">
              <span class="txt-cprimary mr-2 mt-1">•</span>
              <span>
                <strong>Expert Support:</strong> Technical assistance from knowledgeable professionals
              </span>
            </li>
            <li class="d-flex align-items-start">
              <span class="txt-cprimary mr-2 mt-1">•</span>
              <span>
                <strong>Reliable Warranty:</strong> 12-month guarantee on all parts for your peace of mind
              </span>
            </li>
          </ul>
        </div>

        <div class="text-center">
          <h2 class="h4 font-weight-bold mb-4">Visit Our Location</h2>
          <p class="text-muted mb-2">1601 Vine St, Los Angeles, CA</p>
          <p class="text-muted small mb-0">Contact us today for expert advice and premium engine parts</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  
}
</script>